import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import config from './config'
import en from './locales/en.json'
import sv from './locales/sv.json'
// import de from './locales/de'
// import fr from './locales/fr'
import da from './locales/da.json'
import no from './locales/no.json'
import fi from './locales/fi.json'
// import pl from './locales/pl'
// import es from './locales/es'
// import it from './locales/it'
// import nl from './locales/nl'

Vue.use(VueI18n)

function locale() {
  return window.localStorage.getItem('selectedLocale') || 'en'
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || locale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: { en, sv, da, no, fi } //, sv, de, fr, da, no, fi, pl, es, it, nl }
})
